import { useEffect, useRef } from 'react';
import { getVopayUserPaymentMethods } from '../../../redux/actions/payments';

export function useBookingDefaultCreditCardFetcher({
  active,
  requirePayment,
  userId,
  dispatch,
  onFail
}) {
  const lastFetchUserIdRef = useRef(null);

  useEffect(() => {
    if (!active || !requirePayment) {
      lastFetchUserIdRef.current = null;
      return;
    }

    const userIdInt = parseInt(userId, 10);
    if (!Number.isFinite(userIdInt) || userIdInt <= 0) {
      lastFetchUserIdRef.current = null;
      return;
    }

    if (lastFetchUserIdRef.current === userIdInt) {
      return;
    }
    lastFetchUserIdRef.current = userIdInt;

    dispatch(
      getVopayUserPaymentMethods({
        userId: userIdInt,
        params: { type: 'credit' },
        fail: onFail
      })
    );
  }, [active, requirePayment, userId, dispatch, onFail]);
}
